import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      borderWidth: ['base', 'thin'],
    },
    classGroups: {
      'blur': ['blur', 'blur-0', 'blur-sm', 'blur-md', 'blur-lg', 'blur-xl', 'blur-2xl'],
      'font-size': [
        'text-display-sm', 'text-display-md', 'text-display-lg',
        'text-heading-sm', 'text-heading-md', 'text-heading-lg',
        'text-sm', 'text-md', 'text-lg',
        'text-base',
      ],
      'm': ['m-riac-grid'],
      'mt': ['mt-riac-grid'],
      'mb': ['mb-riac-grid'],
      'ml': ['ml-riac-grid'],
      'mr': ['mr-riac-grid'],
      'mx': ['mx-riac-grid'],
      'my': ['my-riac-grid'],
    }
  }
})

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
